import { useQuery } from "@tanstack/react-query"

import {
  v1CustomerPaymentStaticConfig,
  type V1CustomerPaymentStaticConfigResponse,
} from "@be-miniapp/api"

const EMPTY_PAYMENT_STATIC_CONFIG_RESPONSE = {
  flag: 0,
  message: "",
  data: [],
} satisfies V1CustomerPaymentStaticConfigResponse

function getResponseData(value: unknown) {
  if (!value || typeof value !== "object") return undefined
  return (value as { data?: unknown }).data
}

function isPaymentStaticConfigResponse(
  value: unknown
): value is V1CustomerPaymentStaticConfigResponse {
  return (
    !!value &&
    typeof value === "object" &&
    Array.isArray(getResponseData(value))
  )
}

function normalizePaymentStaticConfigResponse(
  value: unknown
): V1CustomerPaymentStaticConfigResponse {
  if (isPaymentStaticConfigResponse(value)) return value

  const nestedValue = getResponseData(value)
  if (isPaymentStaticConfigResponse(nestedValue)) return nestedValue

  const doubleNestedValue = getResponseData(nestedValue)
  if (isPaymentStaticConfigResponse(doubleNestedValue)) return doubleNestedValue

  return EMPTY_PAYMENT_STATIC_CONFIG_RESPONSE
}

export const useCustomerPaymentStaticConfig = () => {
  const queryKey = ["customer-payment-static"]

  return useQuery({
    queryKey,
    queryFn: async () => {
      const response = await v1CustomerPaymentStaticConfig()
      return {
        data: normalizePaymentStaticConfigResponse(response),
      }
    },

    staleTime: Infinity,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
  })
}
